<template>
      <div no-body class="lku-jenisiklan"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col lg="3">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 mr-2">Inventory Name</span></b-input-group-prepend>
                <b-form-input v-model="tblData.jenisiklan" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col md="7">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 mr-2">Platform</span></b-input-group-prepend>
                <b-form-select v-model="tblData.platform" :plain="true" :options="platforms"></b-form-select>
                <b-input-group-prepend><span class="pt-2 mr-2">Position</span></b-input-group-prepend>
                <b-form-input v-model="tblData.posisi" ></b-form-input>
                <b-input-group-append>
                      <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblJenisIklan"
          responsive
          striped hover
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
          <template v-slot:cell(index)="data">
          {{ (tblData.page - 1) * tblData.limit + (data.index + 1)}}
          </template>
          <template v-slot:cell(harga)="data">
            {{data.item.harga|numFormat}}
          </template>
        </b-table>
        <b-row>
          <b-col cols="4">
            <div class="pt-2">
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries
          </div>        
          </b-col>
          <b-col cols="3">            
              <b-row class="ml-2 mt-2">
                <span class="pt-1 pr-2">Limit per page</span>
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
              </b-row>
          </b-col>
          <b-col cols="5">            
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
</template>
<style lang="scss">
  .lku-jenisiklan {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import jiklandigital from "../../apis/jiklandigital";

export default {
  props: ['platformid'],
  data() {
    return {
      jenisiklan_search:'',
      uraian_search:'',
      fields: [
          {
            key: "platform",
            label: "Platform",
            sortable: true
          },
          {
            key: "jenisiklan",
            label: "Inventory",
            sortable: true
          },
          {
            key: "ukuranposisi",
            label: "Size & Position",
            sortable: true
          },
          {
            key: "halamanposisi",
            label: "Page/Canal ",
            sortable: true
          },
          {
            key: "konteniklan",
            label: "Content Type",
            sortable: true
          },
          {
            key: "uraian",
            label: "Remarks",
            sortable: true
          },
          {
            key: "harga",
            label: "Harga",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'jenisiklan',
        sortDesc: false, platform:''
      },
      lkuLoading:false,
      platforms:[{value:'', text:'-- ALL --'}]
    };
  },
  created: async function() {
     this.tblData.platform=this.platformid || '';
     const plt =   await jiklandigital.platform();
     this.platforms = this.platforms.concat(plt);
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
     this.tblData.platform=this.tblData.platform || (this.platformid || '');
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await jiklandigital.list(this.tblData);     
      this.lkuLoading=false;
      return list;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter(ctx) {
        this.tblData.jenisiklan= '';
        this.tblData.platform= '';
        this.tblData.posisi= '';
        this.refresh();
    },
    keymonitor: function(event) {
        // console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblJenisIklan.refresh();
       }
    },    
    search() {
      this.tblData.page=1;
      this.$refs.tblJenisIklan.refresh();
    },
    refresh() {
      this.$refs.tblJenisIklan.refresh();
    }
  }
};
</script>
